import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./DataTable.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { labTestReferenceAllMethods } from "../../../services/LabService";
import useTranslatewrapper from "../../../components/useTranslateWrapper";

function LabTestDataTable(props) {
  const {
    setSampleTableData,
    prepopulatedData,
    testDone,
    isMonitor,
    currentCategoryId,
    setShowButton,
    sampleId
  } = props;
  const {translate} = useTranslatewrapper();
  const [tableData, setTableData] = useState([]);
  const [LabTestDone, setLabTestDone] = useState(testDone || isMonitor);
  const [itemsShow, setItemsShow] = useState(true);
  const [autoPopulatedData, setAutoPopulatedData] = useState(prepopulatedData);
  const [reference, setReference] = useState();

  useEffect(() => {
    if (testDone || isMonitor) {
      getPopulatedData();
    } else {
      getTestResultsData();
    }
  }, [testDone, isMonitor]);

  const addRows = () => {
    setShowButton(true);
    const refData = [...tableData];
    refData.push({
      name: "",
      selectionList: [],
      result: "",
      testMethodFollowed: "",
      defaultPresent: "",
    });
    setTableData((item) => refData);
    setSampleTableData((data) => refData);
  };

  const removeRows = (index) => {
    setShowButton(true);
    let rows = [...tableData];
    if (rows.length > 1) {
      rows.splice(index, 1);
      setTableData(rows);
      setSampleTableData((data) => rows);
    }
  };

  const getPopulatedData = () => {
    const genericData = prepopulatedData;
    const computedArray = [];
    genericData.forEach((item) => {
      // console.log(item, "itemInPopulated")
      computedArray.push({
        isMandatory: item.labTestTypeResponses?.isMandatory,
        name: item.labTestReferenceMethod?.labTestType?.name || item.testName,
        selectionList: [],
        result: item?.labTestReferenceMethod ? "" : item.value,
        range: item?.labTestReferenceMethod && item?.labTestReferenceMethod.minValue !=null
          ? `${item.labTestReferenceMethod?.minValue} - ${item.labTestReferenceMethod?.maxValue}  ${item.labTestReferenceMethod?.uom}`
          : (item?.minValue == null && item?.maxValue == null && item?.defaultPresent == null) ? "-" 
          : (item?.defaultPresent != null && item?.minValue == null && item?.maxValue == null ) ? item?.defaultPresent :
          `${item?.minValue} - ${item?.maxValue} ${item?.uom}`,
        defaultPresentList:item?.labTestReferenceMethod && item?.labTestReferenceMethod?.defaultPresent,
        reference: item.labTestReferenceMethod
          ? item.labTestReferenceMethod.name
          : item?.referenceMethod,
        labTestReferenceMethodId: "",
        uom: item?.labTestReferenceMethod && item?.labTestReferenceMethod?.uom,
        referenceValue: "",
        referenceValueList: "",
        testMethodFollowed: item?.testMethodFollowed ? item?.testMethodFollowed : ""
      });
    });
    setTableData(computedArray);
    // setSampleTableData(computedArray);
  };

  const getTestResultsData = async () => {
    const params = {
      labSampleId: sampleId
    }
    const data = await labTestReferenceAllMethods(currentCategoryId, params);
    if (prepopulatedData && data?.data?.data) {
      const genericData = data.data.data;

      const computedArray = [];
      genericData.forEach((item) => {
        computedArray.push({
          isMandatory: item.labTestTypeResponses.isMandatory,
          name: item.testName || item.labTestTypeResponses.name,
          selectionList: item.labTestReferenceMethodResponses,
          result: "",
          range: "",
          defaultPresentList: item.defaultPresent,
          reference:
            item.labTestReferenceMethodResponses.length === 1
              ? item.labTestReferenceMethodResponses[0].name
              : item.labTestReferenceMethodResponses[0].name,
          labTestReferenceMethodId:
            item.labTestReferenceMethodResponses.length === 1
              ? item.labTestReferenceMethodResponses[0].id
              : item.labTestReferenceMethodResponses[0].id,
          uom:
            item.labTestReferenceMethodResponses.length === 1
              ? item.labTestReferenceMethodResponses[0].uom
              : item.labTestReferenceMethodResponses[0].uom,
              // : "",
          referenceValue: dropDownArray(item.labTestReferenceMethodResponses[0].referenceValue),
          referenceValueList:dropDownArray(item.labTestReferenceMethodResponses[0].referenceValue)
        });
      });

      setTableData(computedArray);
      setSampleTableData(computedArray);
    }
  };
  const dropDownArray =(data)=>{
    return  data!= null && 
    data.split(",")
  }
  const handleReferenceSelection = (event, index) => {
    const refData = [...tableData];
    refData[index].reference = event.target.value;

    const selectIndex = refData[index].selectionList.findIndex(
      (selection) => selection.name === event.target.value
    );
    refData[index].labTestReferenceMethodId =
      refData[index].selectionList[selectIndex].id;
    refData[index].uom = refData[index].selectionList[selectIndex].uom;
    refData[
      index
    ].range = `${refData[index].selectionList[selectIndex].minValue} - ${refData[index].selectionList[selectIndex].maxValue}  ${refData[index].selectionList[selectIndex].uom}`;
    refData[index].referenceValueList = dropDownArray(refData[index].selectionList[selectIndex].referenceValue)
    refData[index].result = " ";

    setTableData((item) => refData);
    setSampleTableData((data) => refData);
  };

  const handleResult = (event, index) => {
    setShowButton(true);
    const refData = [...tableData];
    refData[index].result = event.target.value;
    setTableData((item) => refData);
    setSampleTableData((data) => refData);
  };
  // const handleReferenceValue = (event, index) => {
  //   setShowButton(true);
  //   const refData = [...tableData];
  //   refData[index].result = event.target.value;
  //   setTableData((item) => refData);
  //   setSampleTableData((data) => refData);
  // };

  const getSelectedReference = (item)=>{
    return item.selectionList.find(selectionItem => selectionItem.name === item.reference)
  }
  const getRefValue = (item)=>{
    const selectionList = getSelectedReference(item);
    return (selectionList?.defaultPresent != "string" &&
      selectionList.defaultPresent) ? selectionList.defaultPresent : 
      (selectionList.defaultPresent == null && selectionList.minValue == null && selectionList.maxValue == null) ? 
      "-" :
      `${selectionList.minValue} - ${selectionList.maxValue} ${selectionList.uom}`
  }
  const checkIfReferenceOrRange = (item)=> {
    const selectionList = getSelectedReference(item);
    return selectionList?.referenceValue != null
  }

  const handleName = (event, index) => {
    const refData = [...tableData];
    refData[index].name = event.target.value;
    setTableData((item) => refData);
    setSampleTableData((data) => refData);
  };
  const handleMethod = (event, index) => {
    const refData = [...tableData];
    refData[index].testMethodFollowed = event.target.value;
    setTableData((item) => refData);
    setSampleTableData((data) => refData);
  };

  return (
    <>
      <TableContainer
        sx={{
          border: "1px solid rgba(224, 224, 224, 1)",
          width: "100%",
          display: "flex",
          background: "#ffffff",
        }}
      >
        {itemsShow && (
          <Table aria-label="simple table" className="Test-Data-Table">
            <TableHead sx={{ fontWeight: "bold" }}>
              <TableRow
                sx={{ fontSize: "12px", fontWeight: "bolder", color: "#333" }}
              >
                <TableCell align="left">
                  <Typography
                    sx={{
                      width: "12rem",
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {translate('testName')}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography
                    sx={{
                      width: "10rem",
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {translate('referenceMethod')}
                  </Typography>{" "}
                </TableCell>
                <TableCell align="left">
                  <Typography
                    sx={{
                      width: "10rem",
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {translate('result')}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography
                    sx={{
                      width: "15ch",
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {translate('range')}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography
                    sx={{
                      width: "12rem",
                      fontSize: "12px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    {translate('testMethodFollowed')}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            {tableData?.length > 0 &&
              tableData.map((item, index) => (
                <TableBody key={index}>
                  <TableRow>
                    <TableCell align="left">
                      {item.selectionList?.length > 0 ? (
                        <Typography
                          sx={{
                            width: "8rem",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          {item?.name}{item?.isMandatory && "*"}
                        </Typography>
                      ) : (
                        LabTestDone ? (
                          <Typography
                          sx={{
                            width: "25ch",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          {item?.reference}
                        </Typography>
                        ) :
                      
                      (
                        <TextField
                          sx={{
                            width: "25ch",
                            color: "black",
                          }}
                          disabled={LabTestDone}
                          value={LabTestDone ? item?.reference : item?.name}
                          onChange={(e) => handleName(e, index)}
                        />
                      ))}
                    </TableCell>
                    <TableCell align="left" width="40ch">
                      {item.selectionList?.length > 0 ? (
                        <FormControl fullWidth variant="standard">
                          <Select
                            sx={{
                              fontSize: "12px",
                              color: "black",
                            }}
                            disabled={LabTestDone}
                            value={
                              item.reference ||
                              autoPopulatedData.find(
                                (obj) =>
                                  obj?.labTestReferenceMethod?.labTestType
                                    ?.name === item?.name
                              )?.labTestReferenceMethod?.name
                            }
                            onChange={(e) => handleReferenceSelection(e, index)}
                          >
                            {item.selectionList.map((menuItem) => (
                              <MenuItem
                                sx={{
                                  fontSize: "12px",
                                  color: "black",
                                }}
                                key={menuItem.name}
                                value={menuItem.name}
                              >
                                {menuItem.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : LabTestDone ? (
                        
                        <Typography
                          sx={{
                            width: "25ch",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          {item.name}
                        </Typography>
                        // <TextField
                        //   sx={{
                        //     // width: "25ch",
                        //     fontSize: "8px",
                        //     color: "black",
                        //   }}
                        //   disabled={true}
                        //   variant="outlined"
                        //   value={
                        //     item.name
                        //   }
                        // />
                      ) : (
                        <Typography
                          sx={{
                            width: "25ch",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          {translate('notApplicable')}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {item.selectionList?.length <= 0 ? (
                        <TextField
                          sx={{
                            width: "25ch",
                            fontSize: "8px",
                            color: "black",
                          }}
                          disabled={LabTestDone}
                          type= {(!testDone && !isMonitor) ? "number":""}
                          // {testDone ? disabled: null}
                          variant="outlined"
                          value={
                            item.result ||
                            autoPopulatedData.find(
                              (obj) =>
                                obj?.labTestReferenceMethod?.labTestType
                                  ?.name === item.name
                            )?.value
                          }
                          onChange={(e) => handleResult(e, index)}
                        />

                      ) : checkIfReferenceOrRange(item) ? (
                        <TextField
                          id="outlined-basic"
                          disabled={LabTestDone}
                          type= {(!testDone && !isMonitor) ? "number":""}
                          variant="outlined"
                          size="small"
                          value={
                            item.result ||
                            autoPopulatedData.find(
                              (obj) =>
                                obj?.labTestReferenceMethod?.labTestType
                                  ?.name === item.name
                            )?.value
                          }
                          sx={{ width: "100%" }}
                          // autoFocus={true}
                          select
                          onChange={(e) => handleResult(e, index)}
                        >
                          {Array.isArray(item.referenceValueList) &&
                            item.referenceValueList?.map((data, idx) => {
                              return <MenuItem value={data}>{data}</MenuItem>;
                            })}
                        </TextField>
                      ) : (
                        <TextField
                          sx={{
                            width: "100%",
                            fontSize: "8px",
                            color: "black",
                          }}
                          disabled={LabTestDone}
                          type= {(!testDone && !isMonitor) ? "number":""}
                          // {testDone ? disabled: null}
                          variant="outlined"
                          value={
                            item.result ||
                            autoPopulatedData.find(
                              (obj) =>
                                obj?.labTestReferenceMethod?.labTestType
                                  ?.name === item.name
                            )?.value
                          }
                          onChange={(e) => handleResult(e, index)}
                        />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        sx={{
                          width: "15ch",
                          fontSize: "12px",
                          color: "black",
                        }}
                      >
                        {item?.selectionList?.length ? (getRefValue(item)
                        ) : item.range ? (
                          item.range 
                        ) : item.defaultPresentList ?(
                          item.defaultPresentList
                        ):(
                          <IconButton
                            onClick={() => removeRows(index)}
                            disabled={LabTestDone}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <TextField
                        disabled={LabTestDone}
                        sx={{
                          width: "25ch",
                          color: "black",
                        }}
                        value={
                          autoPopulatedData.find(
                            (obj) =>
                              obj?.labTestReferenceMethod?.labTestType?.name ===
                              item.name
                          )?.testMethodFollowed ||
                          autoPopulatedData.find(
                            (obj) => obj?.labTestReferenceMethod === null
                          )?.testMethodFollowed ||
                          item?.testMethodFollowed
                        }
                        onChange={(e) => handleMethod(e, index)}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
          </Table>
        )}
      </TableContainer>
      <Button
        onClick={addRows}
        disabled={LabTestDone}
        sx={{
          mt: 1,
          color: "#0075FF !important",
          width: "11%",
          textDecoration: "underline",
        }}
      >
        <AddCircleOutlineIcon />
        {translate('addTest')}
      </Button>
    </>
  );
}

export default LabTestDataTable;
